$('.tab--item').on('click', function(e) {

	e.preventDefault();

	$('.tab--item').removeClass('is-expanded');
	$(this).addClass('is-expanded');
	
});